var React = require('react');

function GatsbyLogo (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Slice"),React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("path",{"d":"M20.836 39c-4.581-.164-9.163-1.8-12.6-5.236C4.8 30.327 3 25.745 3 21.327L20.836 39zM24.927 38.51L3.491 17.072C5.29 9.055 12.49 3 21 3c6.055 0 11.29 2.945 14.564 7.364l-3.455 3.127C29.327 9.727 25.91 7.273 21 7.273c-4.686 0-9.782 3.09-11.91 8.818L26 33c4.745-1.636 6-3 8.232-7.727h-6.687V21H39c0 8.51-6.055 15.71-14.073 17.51z","stroke":"#653399","fillRule":"nonzero"}))]);
}

GatsbyLogo.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42"};

module.exports = GatsbyLogo;

GatsbyLogo.default = GatsbyLogo;
